import { MAIN_CHAT_MODE } from '@littlebird/sdk';
import { useParams } from '@tanstack/react-router';
import { useEffect } from 'react';

import {
  defaultUserAllowedChatModes,
  useCurrentChatMode,
} from '@/features/chat/chat.hooks';
import { userStore } from '@/stores/user.store';

// initialise chat mode atom and set default mode if not available in agent modes list
export const useSetChatMode = () => {
  const user = userStore.user;
  const { chatId } = useParams({ strict: false });
  const { currentChatMode, setCurrentChatMode } = useCurrentChatMode();

  useEffect(() => {
    const allowedChatModes = user?.allowed_chat_modes;
    if (!allowedChatModes || allowedChatModes.length === 0) return;

    if (
      !(
        allowedChatModes.includes(currentChatMode) ||
        defaultUserAllowedChatModes.includes(currentChatMode)
      )
    ) {
      const fallbackMode = allowedChatModes.includes(MAIN_CHAT_MODE)
        ? MAIN_CHAT_MODE
        : allowedChatModes[0];

      setCurrentChatMode(fallbackMode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, chatId]);
};
